import { SbsPlayerGlobal } from '../../common';
import { toFormattedDate } from '../../utils';
import { getTID, getUUID } from '../../utils/advertisements';
import SbsPlayerLogger from '../../utils/logger';
import { isMobile } from '../../utils/navigator';

class SmrMediaLog {
  constructor() {
    this.state = {
      send: {
        start: false,
        first: false,
        mid: false,
        third: false,
        end: false,
        retry: 0,
      },
    };
    this.payload = {};
  }

  async getPayload() {
    try {
      const { info, ad, ad_25, ad_30, ad_31, log_15, log_20 } =
        SbsPlayerGlobal.state.data;
      const smrAdVersion = (ad?.smr_ad_version || '2.5').replace(/\./g, '');
      const ad_smr = this.live || smrAdVersion === '25' ? ad_25 : ad_30;

      const smrMediaLogVersion = (ad?.smr_media_log_version || '2.0').replace(
        /\./g,
        ''
      );
      const log_smr = smrMediaLogVersion === '20' ? log_20 : log_15;
      const smrPlatform = isMobile() ? 'MOBILEWEB' : 'PCWEB';
      const smrService =
        (info.type && info.type.toLowerCase() === 'vod') ||
        info.type.toLowerCase() === 'clip'
          ? info.type.toLowerCase()
          : info.onair_yn
          ? 'onair'
          : 'smr';

      const payload = {
        meta: {
          relayversion: 'V10',
          platform: smrPlatform,
          playertype: 'HTML5',
          service: smrService,
          requesttime: toFormattedDate(new Date(), 'yyyyMMddHHmmss'),
          enctype: 'JWT',
          target: 'SMR',
          usetarget: true,
        },
        data: {
          targetversion: log_smr.version,
          api: `https://medialog.smartmediarep.com/api/${
            smrMediaLogVersion === '20' ? 'v20' : 'v15'
          }/tracking/tracking.sb`,
          log: {
            medialog: encodeURIComponent(
              JSON.stringify({
                version: log_smr.version,
                media: log_smr.media,
                site: log_smr.site,
                tid: getTID(ad_smr),
                uuid: getUUID(ad_smr),
                ip: log_smr.ip,
                //trackpoint: command.counter === 0 ? '0' : `${command.counter}/4`,
                gender: log_smr.gender,
                age: log_smr.age,
                platform: SbsPlayerGlobal.state.is_mobile
                  ? 'MOBILEWEB'
                  : 'PCWEB',
                playertype: 'HTML5',
                os: '',
                devicemodel: '',
                telco: '',
                referrer: log_smr.referrer,
                cpid: log_smr.cpid,
                channelid: log_smr.channelid,
                category: log_smr.programid
                  ? log_smr.category
                  : SbsPlayerGlobal.state.data.ad_31.cmdata.category,
                section: log_smr.programid
                  ? log_smr.section
                  : SbsPlayerGlobal.state.data.ad_31.cmdata.section,
                programid: log_smr.programid
                  ? log_smr.programid
                  : SbsPlayerGlobal.state.data.ad_31.cmdata.programid,
                clipid: log_smr.programid
                  ? log_smr.clipid
                  : SbsPlayerGlobal.state.data.ad_31.cmdata.clipid,
                ispay: log_smr.programid
                  ? log_smr.ispay
                  : SbsPlayerGlobal.state.data.ad_31.cmdata.ispay,
                vodtype: log_smr.programid
                  ? log_smr.vodtype
                  : SbsPlayerGlobal.state.data.ad_31.cmdata.vodtype,
                firstplay: log_smr.firstplay,
                adlink: log_smr.adlink,
                like: 0,
              })
            ),
          },
        },
      };

      return payload;
    } catch (error) {
      console.error(error);
    }
  }

  async getPayloadDirect() {
    try {
      const { info, ad, ad_25, ad_30, ad_31, log_15, log_20 } =
        SbsPlayerGlobal.state.data;
      const smrAdVersion = (ad?.smr_ad_version || '2.5').replace(/\./g, '');
      const ad_smr = this.live || smrAdVersion === '25' ? ad_25 : ad_30;

      const smrMediaLogVersion = (ad?.smr_media_log_version || '2.0').replace(
        /\./g,
        ''
      );
      const log_smr = smrMediaLogVersion === '20' ? log_20 : log_15;
      const smrPlatform = isMobile() ? 'MOBILEWEB' : 'PCWEB';
      const smrService =
        (info.type && info.type.toLowerCase() === 'vod') ||
        info.type.toLowerCase() === 'clip'
          ? info.type.toLowerCase()
          : info.onair_yn
          ? 'onair'
          : 'smr';

      const payload = {
        version: log_smr.version,
        media: log_smr.media,
        site: log_smr.site,
        tid: getTID(ad_smr),
        uuid: getUUID(ad_smr),
        ip: log_smr.ip,
        gender: log_smr.gender,
        age: log_smr.age,
        platform: SbsPlayerGlobal.state.is_mobile ? 'MOBILEWEB' : 'PCWEB',
        playertype: 'HTML5',
        os: '',
        devicemodel: '',
        telco: '',
        referrer: log_smr.referrer,
        cpid: log_smr.cpid,
        channelid: log_smr.channelid,
        category: log_smr.programid
          ? log_smr.category
          : SbsPlayerGlobal.state.data.ad_31.cmdata.category,
        section: log_smr.programid
          ? log_smr.section
          : SbsPlayerGlobal.state.data.ad_31.cmdata.section,
        programid: log_smr.programid
          ? log_smr.programid
          : SbsPlayerGlobal.state.data.ad_31.cmdata.programid,
        clipid: log_smr.programid
          ? log_smr.clipid
          : SbsPlayerGlobal.state.data.ad_31.cmdata.clipid,
        adlink: log_smr.adlink,
        playdate: toFormattedDate(new Date(), 'yyyyMMddHHmmss'),
        trackpoint: '0',
        ispay: log_smr.programid
          ? log_smr.ispay
          : SbsPlayerGlobal.state.data.ad_31.cmdata.ispay,
        vodtype: log_smr.programid
          ? log_smr.vodtype
          : SbsPlayerGlobal.state.data.ad_31.cmdata.vodtype,
        firstplay: log_smr.firstplay,
        like: 0,
      };

      return payload;
    } catch (error) {}
  }

  init() {
    SbsPlayerGlobal.events.addEventListener(
      'live-midroll-program-changed',
      (event) => {
        console.info('live-midroll-program-changed');
        this.state.send.start = false;
      }
    );
  }

  async send(position) {
    try {
      // * Validate position
      if (!position || isNaN(position)) return false;
      // * Check retry limit
      if (this.state.retry > 3) return false;

      if (Object.keys(this.payload).length === 0) {
        // * 릴레이서버(gateway.sbs.co.kr) 통해서 보내지 않고 직접 전송으로 변경
        //this.payload = await this.getPayload();
        this.payload = await this.getPayloadDirect();
      }

      let trackingPoint;
      if (position >= 0.0) trackingPoint = '0';
      if (position >= 0.25) trackingPoint = '1/4';
      if (position >= 0.5) trackingPoint = '2/4';
      if (position >= 0.75) trackingPoint = '3/4';
      if (position >= 0.99) trackingPoint = '4/4';
      if (SbsPlayerGlobal.target === 'live') trackingPoint = '0';

      if (trackingPoint === '0' && this.state.send.start) return false;
      if (
        trackingPoint === '1/4' &&
        this.state.send.first &&
        SbsPlayerGlobal.target !== 'live'
      )
        return false;
      if (
        trackingPoint === '2/4' &&
        this.state.send.mid &&
        SbsPlayerGlobal.target !== 'live'
      )
        return false;
      if (
        trackingPoint === '3/4' &&
        this.state.send.third &&
        SbsPlayerGlobal.target !== 'live'
      )
        return false;
      if (
        trackingPoint === '4/4' &&
        this.state.send.end &&
        SbsPlayerGlobal.target !== 'live'
      )
        return false;

      //this.payload.data.trackpoint = trackingPoint;
      //this.sendPayload();

      this.payload.trackpoint = trackingPoint;
      this.sendPayloadDirect(this.payload);

      if (trackingPoint === '0') this.state.send.start = true;
      if (trackingPoint === '1/4') this.state.send.first = true;
      if (trackingPoint === '2/4') this.state.send.mid = true;
      if (trackingPoint === '3/4') this.state.send.third = true;
      if (trackingPoint === '4/4') this.state.send.end = true;
    } catch (error) {
      console.error(error);
    }
  }

  sendPayload() {
    console.log('SmrMediaLog.sendPayload', JSON.stringify(this.payload));

    fetch(SbsPlayerGlobal.url.gateway, {
      method: 'post',
      headers: new Headers({
        'Content-Type': 'application/json;charset=UTF-8',
      }),
      body: JSON.stringify(this.payload),
    }).catch(() => this.state.retry++);
  }

  async sendPayloadDirect(data) {
    try {
      const { ad } = SbsPlayerGlobal.state.data;
      const smrMediaLogVersion = (ad?.smr_media_log_version || '2.0').replace(
        /\./g,
        ''
      );

      const jwtResponse = await fetch(
        `${SbsPlayerGlobal.url.api.jwt}?value=${encodeURIComponent(
          JSON.stringify(data)
        )}`
      );

      if (jwtResponse.status === 200) {
        const result = await jwtResponse.json();
        const trackingUrl = `https://medialog.smartmediarep.com/api/${
          smrMediaLogVersion === '20' ? 'v20' : 'v15'
        }/tracking/tracking.sb?medialog=${result.value}`;
        // FormData 객체 생성
        const formData = new FormData();
        formData.append('token', result.value);
        // const requestOptions = {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json;charset=UTF-8'
        //   },
        //   redirect: 'follow'
        // };
        const requestOptions = {
          method: 'POST',
          body: formData,
          redirect: 'follow',
        };

        await fetch(trackingUrl, requestOptions);
      } else {
        console.log('JWT Fetch Response:', jwtResponse);
      }
    } catch (error) {
      console.error('Error in sendPayloadDirect:', error);
    }
  }
}

export default SmrMediaLog;
